const WemRoutes = {
  content: '/umbraco/api/loyalty/content',
  contactSupport: '/api/loyalty/support/Email',
  deals: '/api/loyalty',
  dealCategories: '/api/loyalty/deals/categories',
};

export default WemRoutes;
